let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8GcsS")).then(() => parcelRequire('1ADXg'));